import { useEffect, useState } from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

import { debounce } from '../../helpers/common.helpers';
import AppConfig from '../../providers/AppConfig';
import { BaseLoaderSpinner } from '..';

const { Option } = Select;

export const BaseFetchSelect = (props) => {
  const { field, onBlur, onChange, queryUrl, exclude, ...rest } = props;

  const [lastFetchId, updateFetchId] = useState(0);
  const [value, setValue] = useState({ key: '', value: '' });
  const [data, setData] = useState({ response: [], fetching: false });

  const { t } = useTranslation();

  const incrementFetchId = () => updateFetchId((id) => id + 1);

  useEffect(() => {
    if (!field.value || !field.value.label) {
      // oxlint-disable-next-line react-hooks/set-state-in-effect
      setValue({ key: '', value: '' });
    }
  }, [field.value]);

  const fetchUser = debounce((value) => {
    if (value.length < 2) {
      return;
    }

    incrementFetchId();
    const fetchId = lastFetchId;
    setData({ response: [], fetching: true });

    axios(`${queryUrl}${value}`).then((body) => {
      if (fetchId !== lastFetchId) {
        return;
      }
      const filterOut = exclude.map((e) => e.key);
      const response = body.data.data
        .filter((user) => !filterOut.includes(user.id))
        .map((user) => ({
          key: user.id,
          label: `${user.first_name} ${user.last_name}`,
          email: user.email,
        }));

      setData({ response, fetching: false });
    });
  }, AppConfig.searchDebounceTime);

  const change = (selected) => {
    const selectedId = selected.value ?? selected.key;
    const item = data.response.find((d) => d.key === selectedId);
    if (!item) return;

    setData({ response: [], fetching: false });
    setValue(item);
    onChange(item);
  };

  return (
    <Select
      {...field}
      {...rest}
      showSearch
      labelInValue
      value={value}
      defaultActiveFirstOption={false}
      suffixIcon={null}
      filterOption={false}
      placeholder={t('userGroups.edit.selectUsers')}
      notFoundContent={data.fetching ? <BaseLoaderSpinner small isComponent /> : null}
      onSearch={fetchUser}
      onChange={change}
      loading={data.fetching}
      classNames={{ popup: { root: 'base-fetch-select-dropdown' } }}
    >
      {data.response.map((d) => (
        <Option key={d.key} value={d.key}>
          {d.label} - {d.email}
        </Option>
      ))}
    </Select>
  );
};
